export * from './Map';
export {default} from './Map';
